import React, { useMemo, useCallback, useState } from 'react';
import { RiDeleteBin2Line, RiEyeLine } from 'react-icons/all';
import IconButton from '@mui/material/IconButton';
import DataGrid from 'composant/UI/DataGrid/DataGrid';

const COLUMN_CONFIG = [
  ['name', 'Titre', 200, 1.4],
  ['cron_start_day', 'Date de début', 180, 1],
  ['cron_end_date', 'Date de fin', 180, 1],
];

const createColumn = (
  field: string,
  headerName: string,
  minWidth: number,
  flex: number
) => ({
  field,
  headerName,
  minWidth,
  flex,
  sortable: true,
  align: 'center' as const,
  headerAlign: 'center' as const,
});

const TableauPlanningExceptionnel = ({
  selectioneLigne,
  exPlannings,
  onDelete,
  onView,
}: {
  selectioneLigne: any;
  exPlannings: any[];
  onDelete: (row: any) => void;
  onView: (row: any) => void;
}) => {
  const [selectionModel, setSelectionModel] = useState([]);

  const columns = useMemo(
    () => [
      ...COLUMN_CONFIG.map(([field, headerName, minWidth, flex]: any) =>
        createColumn(field, headerName, minWidth, flex)
      ),
      {
        field: 'actions',
        headerName: 'Actions',
        minWidth: 150,
        flex: 0.8,
        editable: false,
        sortable: false,
        align: 'center' as const,
        headerAlign: 'center' as const,
        renderCell: (params: any) => (
          <>
            <IconButton
              aria-label="delete"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(params.row);
              }}
            >
              <RiDeleteBin2Line size={20} />
            </IconButton>
            <IconButton
              aria-label="Afficher"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onView(params.row);
              }}
              sx={{
                '&:hover': {
                  backgroundColor: '#f0af00',
                  color: 'white',
                },
              }}
            >
              <RiEyeLine size={20} />
            </IconButton>
          </>
        ),
      },
    ],
    [onDelete, onView]
  );

  const handleSelectionModelChange = useCallback(
    (newSelection) => {
      setSelectionModel(newSelection);
      const selectedRow = exPlannings?.find(
        (row) => row.task_id === newSelection[0]
      );
      if (selectedRow) {
        selectioneLigne(selectedRow);
      }
    },
    [exPlannings, selectioneLigne]
  );

  if (!exPlannings?.length) {
    return null;
  }

  return (
    <DataGrid
      rows={exPlannings}
      columns={columns}
      getRowId={(row: any) => row.task_id}
      onRowSelectionModelChange={handleSelectionModelChange}
      rowSelectionModel={selectionModel}
      disableMultipleRowSelection
      pageSizeOptions={[25, 50, 100]}
      initialPageSize={25}
      autoRowHeight
    />
  );
};

export default TableauPlanningExceptionnel;
